import { gql } from '@apollo/client'

export const SelfReflectionQuestionsFragment = gql`
  fragment SelfReflectionQuestion on SelfreflectionQuestion {
    id
    textId
    value
    comment
    position
    type
    meetingId
    subItems {
      id
      textId
      value
      position
    }
  }
`
